import primaryButton from '../../../../primary-button';

const secondary = (params) => primaryButton.brandedSolid.background.default.secondary(params);

export default secondary;
